import { VisibilityOff } from "@mui/icons-material";

const VisibilityOffIcon = () => (
  <VisibilityOff  />
);

export default VisibilityOffIcon;